import React, { Component } from 'react';
import { Col, Row, Label } from 'reactstrap';
import { AvGroup, AvField } from 'availity-reactstrap-validation';
import MaterialIcon from 'material-icons-react';
import i18n from '../../../../i18next';

class OrderAmounts extends Component {
    constructor(props) {
        super(props);

        this.state = {
            currency: null
        }
    }

    componentDidUpdate(prevProps) {
        if (this.props.currency !== prevProps.currency) {
            this.setState({
                currency: this.props.currency
            });
        }
    }

    negativeDecimalsValidation(e) {
        let inputKeyCode = e.keyCode ? e.keyCode : e.which;

        if (inputKeyCode != null) {
            if (inputKeyCode == 43 || inputKeyCode == 45 || inputKeyCode == 69
                || inputKeyCode == 101) e.preventDefault();
        }
    }

    render() {
        const { posAsyncTimeInput, rowStyler, labelPadding, orderAmountAvGroup, currencyTypeStyle, containerStyle, headerTitle, headerStyle } = this.props.styles;
        const currencyType =this.state.currency;

        return (
            <Col style={containerStyle}>
                <Row>
                    <div style={headerStyle}>
                        <MaterialIcon icon="local_atm" color="#0288d1" size={20} />
                        <span style={headerTitle}>{i18n.t('common:deliveryCollectionDineInCurbside.minMaxOrderAmount')}</span>
                    </div>
                </Row>
                <Row style={rowStyler}>
                    <AvGroup style={orderAmountAvGroup}>
                        <Label style={labelPadding}>{i18n.t('common:deliveryCollectionDineInCurbside.minOrderAmount')}</Label>
                        <AvField
                            type="number" name="minimumOrderAmount"
                            value={this.props.minimumOrderAmount}
                            onChange={this.props.changeOrderAmountState}
                            style={posAsyncTimeInput}
                            min={1} required onKeyPress={(e) => this.negativeDecimalsValidation(e)}
                        />
                        <Label style={currencyTypeStyle}>{currencyType}</Label>
                    </AvGroup>
                    <AvGroup style={orderAmountAvGroup}>
                        <Label style={labelPadding}>{i18n.t('common:deliveryCollectionDineInCurbside.maxOrderAmount')}</Label>
                        <AvField
                            type="number" name="maximumOrderAmount"
                            value={this.props.maximumOrderAmount}
                            onChange={this.props.changeOrderAmountState}
                            style={posAsyncTimeInput}
                            min={0} onKeyPress={(e) => this.negativeDecimalsValidation(e)}
                        />
                        <Label style={currencyTypeStyle}>{currencyType}</Label>
                    </AvGroup>
                </Row>
            </Col>
        );
    }
}

export default OrderAmounts;


// WEBPACK FOOTER //
// ./src/components/restaurants/settings/service/OrderAmounts.js